<template>
  <div class="content">
      <div style="padding-top: 20px;"></div>
     
      <div style="display: none"></div>
      <div ref="alipayWeb" v-html="alipay"></div>
      <div class="form-class">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="金额" prop="price">
                  <el-input-number v-model="ruleForm.price"  :precision="2" :min="0.01" :max="100000000" :step="1"></el-input-number>
              </el-form-item>
              <el-form-item label="支付方式" prop="pay_way">
                  <el-radio-group v-model="ruleForm.pay_way">
                      
                  <el-radio label="1" style="color: chartreuse;">  <el-image
                    style="width: 70px; height: 30px"
                    :src="alipayLogo"></el-image></el-radio>
                  <el-radio label="2" style="color: chartreuse;"><el-image
                    style="width: 30px; height: 30px"
                    :src="weixinPayLogo"
                    ></el-image>微信</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item>
                  <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
              </el-form-item>
          </el-form>

      </div>

      <el-dialog
        title="支付"
        :visible.sync="wxPayDialogVisible"
        width="30%"
        :before-close="handleClose" center>
        <span style="margin-left: 40%;">
        <el-image   :src="pay_qrcode"></el-image></span>
        <span v-if="tipFlag" style="color: red;">{{ tip }}</span>
        <span v-else style="color: green;">{{ tip }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="wxPayDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

  </div>
</template>
<script>
import alipayLogo from '@/assets/alipay.png'
import weixinPayLogo from '@/assets/weixintubiao.png'
import {Form, Message} from 'element-ui';
export default {
  data() {
    return {
      wxPayDialogVisible:false,
      weixinPayLogo:weixinPayLogo,
      alipayLogo:alipayLogo,
      ruleForm: {
        remark:'',
        pay_way: '',
        price:0
      },
      alipay:'',
      tip:'请扫码支付',
      tipFlag:true,
      pay_qrcode:'',
      options:[],
      orderNo:'',
      timerNum:0,
      qq_contact:'',
      timer:null,
      payBtn:false,
      rules: {
        price: [
          { required: true, message: '请填写金额', trigger: 'blur' }
        ],
        pay_way: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
   
    submitForm(formName) {
      let self = this;
      self.payBtn = true;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.postRequest('/shengyi_smart/payCode',self.ruleForm).then(resp =>{
               self.payBtn=false;
               if(resp.err >= 500){
                  Message.error({message: resp.msg});
                  return;
               }
              if(self.ruleForm.pay_way == 1){
                  //self.alipay = resp.data.sign;
                  self.pay_qrcode = resp.data.qrcode;
                  self.orderNo = resp.data.order_no;
                  self.wxPayDialogVisible=true;
                 //// self.$nextTick(()=>{
                   //   self.$refs.alipayWeb.children[0].submit();
                 // });
              }else if(self.ruleForm.pay_way == 2){
                  self.pay_qrcode = resp.data.qrcode
                  self.orderNo = resp.data.order_no;
                  self.wxPayDialogVisible=true;
              }
              self.queryOrder();

          })
        } else {
          self.payBtn=false;
          console.log('error submit!!');
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    queryOrder(){
      let self = this;
      self.timer = setTimeout(() => {
        //需要定时执行的代码
        console.debug("Hello World:"+self.timerNum);
        let q = {
          order_no:self.orderNo
        };
        if(self.timerNum >= 100){
          clearTimeout(self.timer);
          self.tip="支付失败，如已支付，请联系客服";
          Message.error({message: "支付失败，如已支付，请联系客服"});
          return;
        }
        self.postRequest('/shengyi_smart/query',q).then(resp =>{
          self.timerNum++;
               if(resp.err >= 500){
                  Message.error({message: resp.msg});
                  return;
               }
               self.tip="查询支付结果中.....";
               let order = resp.data;
               if(order){
                var payStatus = order.pay_status;
                if(payStatus == 1){
                  self.tip="支付成功";
                  Message.success({message: "支付成功"});
                  self.tipFlag = false;
                  clearTimeout(self.timer);
                }
    
               }
          
          })
          self.queryOrder();
        }, 5000)
    }
  },
}
</script>
<style scoped>
  .title-class{
      padding-left: 140px;
      padding-top: 30px;
  }
  .get-role{
      margin-left: 10px;
  }
  .content{
      margin: 0 auto;
      margin-top: 50px;
      align-content: center;
      width: 50%;
      height: 600px;
      max-height: 800px;
      background-color: rgb(161, 194, 203);
      border-radius: 20px;
  }
  .form-class{
      padding-top: 20px;
      padding-left: 90px;
      width: 60%;
  }

</style>